export default function OpenStepAccordeonIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} viewBox="0 0 24 11" xmlns="http://www.w3.org/2000/svg">
        <path d="m20.706 0.41991c0.7501-0.55989 1.9796-0.55989 2.7296-1e-6 0.3789 0.28283 0.5645 0.65224 0.5645 1.0216s-0.1856 0.73881-0.5645 1.0216l-8.6991 6.4935-2.7374 2.0433-2.7296-2.0433-8.7069-6.4935c-0.75006-0.56565-0.75006-1.4776 0-2.0433 0.7578-0.55988 1.9795-0.55988 2.7373 0l8.7069 6.4935 8.6991-6.4935z"/>
      </svg>
    </>
  );
}